// extracted by mini-css-extract-plugin
export default {"skillsSection":"MySkills_skillsSection__fbVHR","skillsContainer":"MySkills_skillsContainer__Lb6Tt","skill":"MySkills_skill__zBY+I"};